// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2yUcg","insightsList":"newBusinessInsightsMenu_insightsList__PL6YO","active":"newBusinessInsightsMenu_active__3Gx9p"};